import { Field, FIELD_TYPES, Model } from "../../../vue-ocom/schema";

export default Model("form_entry_file", {
  verbose_name: "Form Entry File",
  verbose_name_plural: "Form Entry Files",
  fields: [
    Field("id", {
      label: "ID",
      primary_key: true,
      readonly: true,
      hide: false,
      field_type: FIELD_TYPES.AutoNumber,
    }),

    Field("file", {
      label: "File",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "filesystem.FileMetaData",
      ref_display_field: "original_filename",
      default: () => {
        return null;
      },
    }),
    Field("uuid", {
      label: "UUID",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.UUID,
      default: () => {
        return null;
      },
    }),
  ],
});
